module.exports = __webpack_public_path__ + "static/media/img_buble_01.73e02c12.png";